import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router, Data } from "@angular/router";
import { CommonService } from "@services/common.service";
import { CanvasService } from "@services/canvas.service";
import { MatDialog } from "@angular/material/dialog";
import { PublishingDialogComponent } from "@dialogs/publishing/publishing.component";

@Component({
    selector: "app-publish",
    templateUrl: "./publish.component.html",
    styleUrls: ["./publish.component.scss"],
    standalone: false
})
export class PublishPageComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private canvasService: CanvasService,
    public commonService: CommonService,
    public dialog: MatDialog
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.publishListener = this.canvasService
      .listenForPublish()
      .subscribe(() => {
        this.openPublishDialog();
      });
  }
  public user_name: string = "";
  private publishListener: any;

  public accessAllowed: boolean = true;
  public selectedReports: any = null;
  public selectedDashboards: any = null;
  public selectedCanvases: any = null;
  public toggleRefresh: any = null;
  categories: any;
  userCategories: any;

  public canvasMode = "publish";

  public canvasType = "report";

  tabClick(event: any) {
    console.log(event);
    if (event.index == 0) this.canvasMode = "publish";
    if (event.index == 1) this.canvasMode = "schedule";
  }

  openPublishDialog(): void {
    this.toggleRefresh = null;
    setTimeout(() => {
      this.selectedCanvases = this.selectedReports.concat(
        this.selectedDashboards
      );

      this.selectedCanvases = this.selectedCanvases.map((data: any) => {
        return data.id;
      });
      if (this.selectedCanvases.length > 0) {
        const dialogRef = this.dialog.open(PublishingDialogComponent, {
          disableClose: true,
          data: {
            message:
              "Publish these " + this.selectedCanvases.length + " canvases?",
            actionButton: "PUBLISH",
          },
          panelClass: "canvas-dialog",
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            const formBody = { canvasIds: this.selectedCanvases };
            this.canvasService
              .publishCanvases(formBody)
              .subscribe((data: any) => {
                this.toggleRefresh = data;
              });
          }
        });
      }
    }, 200);
  }
  reportCanvases(event: any) {
    this.selectedReports = event;
  }
  dashboardCanvases(event: any) {
    this.selectedDashboards = event;
  }
  getCategories() {
    this.commonService.getAllCategories().subscribe((data: any) => {
      this.categories = data.data;
    });
  }

  ngOnInit(): void {
    this.getCategories();
  }
}
